// removed by extract-text-webpack-plugin
module.exports = {"head":"r04jBesBxDPumIpZfjr86","texts":"_26AeixBYDjc4ohylnhYrfB","title":"_1YXAtzGfwylrZye57sFUsv","lower":"_1-ez9XASRJgoAmIAo92geb","button":"DLQmzP5FKPA4HvBLJXr9R","demo":"_129zeDyfwcvQNOSpsmYUtY"};


//////////////////
// WEBPACK FOOTER
// ./src/App/Pages/Home/Home/Top/styles.css
// module id = 1054
// module chunks = 21